import calls from '@/backend/api-calls'

const state = {
  permissions: [],
  policies: [],
  loading: false
}

const getters = {
}

const actions = {
  getAllPermissions: ({commit}) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.permissions.get().then(resp => {
        commit("setPermissions", resp.data);
        commit("setLoading", false);
        resolve(resp);
      }).catch(err => {
        commit("setLoading", false);
        reject(err)
      });
    })
  },
  getPolicies: async ({commit}, parameters) => {
    return new Promise((resolve, reject) => {
      calls.permissions.getPolicies(parameters).then(resp => {
        commit("setPolicies", resp.data);
        resolve(resp);
      }).catch(err => {
        reject(err)
      });
    })
  },
  addPolicy({commit}, { data, parameters }) {
    return new Promise((resolve, reject) => {
      calls.permissions.post(data, parameters)
        .then(resp => {
          commit("insertPolicy", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Policy successfully added'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updatePolicy: ({commit}, { policyId, data }) => {
    return new Promise((resolve, reject) => {
      calls.permission.put(policyId, data).then(
        resp => {
          commit("insertUpdatedPolicy", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Policy successfully updated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deletePolicy: ({commit}, policyId) => {
    return new Promise((resolve, reject) => {
      calls.permission.delete(policyId).then(
        resp => {
          commit("removePolicy", policyId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Policy successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  setUserPolicy: ({commit}, { policyId, data }) => {
    return new Promise((resolve, reject) => {
      calls.permission.putUserPolicy(policyId, data).then(
        resp => {
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'User policy successfully updated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
}

const mutations = {
  setPermissions: (state, data) => {
    state.permissions = data;
  },
  insertPolicy(state, data) {
    state.policies.push(data);
  },
  insertUpdatedPolicy(state, data) {
    state.policies.forEach((policy, i) => {
      if (policy.id == data.id) {
        state.policies.splice(i, 1, data);
      }
    })
  },
  removePolicy(state, policyId) {
    state.policies.forEach((policy, i) => {
      if (policy.id == policyId) {
        state.policies.splice(i, 1);
      }
    })
  },
  setPolicies: (state, data) => {
    state.policies = data;
  },
  setLoading(state, status) {
    state.loading = status;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
